import type { OwnerReference } from '@/kubernetes/components/workloadLink/workloadLink.types';

export type { OwnerReference };

// 타입 가드는 src/kubernetes/utils/types.ts의 isCustomValueField를 사용하세요

export const LOG_POS = {
  head: 1,
  tail: 2,
} as const;
export type LogPosType = (typeof LOG_POS)[keyof typeof LOG_POS];

export interface ContainerLogLine {
  timestamp: string;
  log: string;
}
